import { object, string } from "yup";

import { LoginMessages } from "@/messages/login/login.messages";

import { LoginFormData } from "./types";

export const buildLoginFormInitialData = (): LoginFormData => {
  return {
    login: "",
    password: "",
    email: "",
  };
};

export const buildLoginFormSchema = (messages: LoginMessages) =>
  object().shape({
    email: string().email(messages.errorInvalidEmail).required(messages.errorRequiredEmail),
    password: string().required(messages.errorRequiredPassword),
  });
